export const formatVideoDuration = (durationInSeconds?: number | null) => {
    if (!durationInSeconds || durationInSeconds < 0) {
        return '00:00';
    }

    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;

    if (hours > 0) {
        return [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':');
    }

    return [minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':');
};
